import { render } from "./Projects.vue?vue&type=template&id=7c3855a4&scoped=true"
const script = {}

import "./Projects.vue?vue&type=style&index=0&id=7c3855a4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3855a4"]])

export default __exports__